import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { ICreateZoomConnectionsJobResult, IRoomsUploadJobDetails } from '../../../api/jobs.dao';

const createZoomConnectionsForRoomsJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IRoomsUploadJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IRoomsUploadJobDetails, ICreateZoomConnectionsJobResult>) => {
        const {createdZoomMeetingCount, failedCreateZoomMeetingCount} = props.result;
        return (
            <div className='create-zoom-mettings-result-alert'>
                <div>{createdZoomMeetingCount} Zoom connections were created</div>
                <div>Could not create Zoom connection for {failedCreateZoomMeetingCount} Rooms</div>
            </div>
        );
    },
    failedComponent: () => {
        return <>Zoom Connections generation has failed</>;
    },
};

export { createZoomConnectionsForRoomsJobProperties };
